import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import BackToLoginButton from './BackToLoginButton';

const BackToLoginButtonPicker = (props) => {
  const { resource } = useMetaLayoutContext();

  return pickFunction(resource, {
    [fr.relationships.login.name]: () => {
      return (
        <BackToLoginButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default BackToLoginButtonPicker;
